import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useStores } from '../../hooks/useStore';
import { RootStore } from '../../stores/RootStore';
import { BaseLayout } from '../../components/BaseLayout';
import { siteNavigate } from '../../services/nav';
import { LoaderSpinner } from '../../components/Loader/Loader';
import { bookAllProducts, handOffBooking, paymentAuth, siteConfiguration, setupPaymentPlan, } from '../../hooks/useRequest';

import Atba from '../../components/assets/atba.svg';
import Atol from '../../components/assets/atol.svg';

import atolIconDefault from '../../components/assets/icons/default/04/Atol.svg';
import atbaIconDefault from '../../components/assets/icons/default/04/abta-1.svg';

export function RyanAirConfirm() {

    const fNav = useNavigate();
    const [searchParams] = useSearchParams();
    const [loadingIndicator, setLoadingIndicator] = useState(false);

    const {
        RootStore: {
            userToken,
            configuration,
        },
    } = useStores() as { RootStore: RootStore };

    async function setUpDirectDebit(_bookingId: number, sessionId: string) {
        const ddDetail = sessionStorage.getItem('ddDetail');
        if(ddDetail == null){
          return
        }
        const ddDetailObj = JSON.parse(ddDetail)
        try {
          await setupPaymentPlan(
            userToken,
            sessionId,
            _bookingId,
            ddDetailObj.planID,
            ddDetailObj.accountHolder,
            '',
            ddDetailObj.accountNumber,
            ddDetailObj.sortCode,
            ddDetailObj.bankName,
            ddDetailObj.bankAddress,
            ddDetailObj.bankPostCode,
          );
        } catch (error) {
          console.log('Unable to set up direct debit', error);
        }
      }

    async function processBooking(_bookingId: number, sessionId: string) {

        const bookComs = await siteConfiguration('12', userToken)
        if(bookComs == 0){
          siteNavigate(configuration, `/booking-confirmed/?session=${sessionId}&bid=${_bookingId}`, fNav);
          return;
        }
        setLoadingIndicator(true);
        await bookAllProducts(userToken, sessionId, _bookingId);
        await handOffBooking(userToken, sessionId, _bookingId);
  
        const ddDetail = sessionStorage.getItem('ddDetail');
        if(ddDetail != null){
          await setUpDirectDebit(_bookingId, sessionId);
        }
    }

    useEffect(() => {

        let _done = false;
        window.addEventListener('message', msg => {
            if (msg.data.type === 'RYANAIR_TELEMETRY') {
                const payload = msg.data.payload;
                if (payload.state === 'REDIRECT' && payload.status === 200 && _done == false) {
                    // flight confirmation has been completed!
                    console.log('flight confirmation successful!');
                    //redirect to book
                    const sessionId = searchParams.get('session');
                    const _bookingId = searchParams.get('bid');
                    _done = true;

                    if(_bookingId != null && sessionId != null){
                        const bid = Number(_bookingId)
                        processBooking(bid, sessionId).then(() => {
                            siteNavigate(configuration, `/booking-confirmed/?session=${sessionId}&bid=${bid}`,fNav);
                        })
                    }
              

                    return;
                }
            }
        }, false);

    }, []);

    const ryanAirSession = searchParams.get('ryr_session');
    const src = "https://ryanairbc.paxport.net/confirm?agent=" + configuration.ryr_agt + "&session=" + ryanAirSession + "&target=test";
 
      if(loadingIndicator){

        let atolIco = atolIconDefault;
        let abtaIco = atbaIconDefault;
      
        if(configuration.icon_set == 'blue'){
          atolIco = Atol;
          abtaIco = Atba;
        }

    

return (<BaseLayout userToken={configuration.userToken} userConfiguration={configuration}>
    <div style={{ display: 'flex', justifyContent: 'center', padding:'0px' }}>
        <h2>Confirm with Ryanair</h2>
    </div>
    <div style={{ display: 'flex', justifyContent: 'center', paddingLeft:'15px', paddingRight: '15px' }}>
        <p>Please confirm you're flight details. Please wait for the window below to load it can take a little while...</p>
    </div>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: '25px', marginRight: '25px', marginBottom: '10px' }}>
            <div className='credit-card-container'>
               <div className='credit-card-loader-text'>Booking your holiday.</div>
                <div className='credit-card-loader'>
                <div className='credit-card-rel-container'>
                    <LoaderSpinner />
                </div>
                <div className='credit-card-loader-tag'>Please wait...<br></br>Do not refresh your browser.</div>
                <div className='credit-card-flex-center'>
                    <div>
                    <img src={abtaIco} height={170} width={170} />
                    </div>
                    <div>
                    <img src={atolIco} height={75} width={75} />
                    </div>
                </div>
                </div>
            </div>
    </div>
</BaseLayout>)

      }

    return (


        <BaseLayout

            userToken={configuration.userToken}
            userConfiguration={configuration}
        >


            <div style={{ display: 'flex', justifyContent: 'center', padding:'0px' }}>
                <h2>Confirm with Ryanair</h2>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', paddingLeft:'15px', paddingRight: '15px' }}>
                <p>Please confirm you're flight details. Please wait for the window below to load it can take a little while...</p>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: '25px', marginRight: '25px', marginBottom: '10px' }}>
                <iframe
                    id="ryr-flight-confirm-frame"
                    src={src} width="100%" height="950"
                    style={{border: 'none'}}
                    sandbox="allow-scripts allow-same-origin">
                    <p>iFrame not loaded!</p>
                </iframe>
            </div>

        </BaseLayout>)
}